/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { capitalize } from '@veeam-vspc/core';
import { colors as palette } from '@veeam-vspc/components';

import { BaseTrendChart } from '../../../BaseTrendChart';
import { VmReplicasService } from './services/vm-replicas.service';
import { useLang } from 'views/providers/LangProvider/hooks';

export const VmReplicas: React.FC = () => {
    const lang = useLang();

    const params = {
        colors: [palette.B400],
        yTitle: lang.REPLICAS,
    };

    return (
        <BaseTrendChart
            params={params}
            service={VmReplicasService}
            title={{ text: capitalize(lang.VM_REPLICAS) }}
        />
    );
};
